import { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";
import { Input } from "@/components/ui/input";
import { FormField } from "@/components/forms/FormField";
import { api } from "@/lib/api";

const Pick = ({ id, value, items, onChange, disabled }) => (
  <div className="relative">
    <select
      id={id}
      value={value}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
      className="h-12 w-full appearance-none rounded-md border border-input bg-background px-3 pr-10 text-base text-foreground focus:outline-none focus:ring-2 focus:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm"
      data-testid={`${id}-select`}
    >
      <option value="">Seleziona</option>
      {items.map((i) => <option key={i} value={i}>{i}</option>)}
    </select>
    <ChevronDown className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 opacity-50" />
  </div>
);

export const AddressFields = ({ value, onChange, errors = {}, prefix }) => {
  const [regioni, setRegioni] = useState([]);
  const [province, setProvince] = useState([]);
  const [comuni, setComuni] = useState([]);

  useEffect(() => { api.get("/geo/regioni").then((r) => setRegioni(r.data)); }, []);
  useEffect(() => {
    setProvince([]);
    if (value.regione) api.get("/geo/province", { params: { regione: value.regione } }).then((r) => setProvince(r.data));
  }, [value.regione]);
  useEffect(() => {
    setComuni([]);
    if (value.provincia) api.get("/geo/comuni", { params: { provincia: value.provincia } }).then((r) => setComuni(r.data));
  }, [value.provincia]);

  const pickComune = (c) => onChange({ ...value, comune: c, cap: comuni.find((x) => x.nome === c)?.cap || "" });

  return (
    <div className="grid gap-4 sm:grid-cols-3">
      <FormField id={`${prefix}-regione`} label="Regione">
        <Pick id={`${prefix}-regione`} value={value.regione} items={regioni}
          onChange={(r) => onChange({ ...value, regione: r, provincia: "", comune: "", cap: "" })} />
      </FormField>
      <FormField id={`${prefix}-provincia`} label="Provincia">
        <Pick id={`${prefix}-provincia`} value={value.provincia} items={province.map((p) => p.nome)}
          disabled={!value.regione} onChange={(p) => onChange({ ...value, provincia: p, comune: "", cap: "" })} />
      </FormField>
      <FormField id={`${prefix}-comune`} label="Comune" error={errors.comune}>
        <Pick id={`${prefix}-comune`} value={value.comune} items={comuni.map((c) => c.nome)}
          disabled={!value.provincia} onChange={pickComune} />
      </FormField>
      <FormField id={`${prefix}-indirizzo`} label="Indirizzo (via e numero civico)" error={errors.indirizzo} className="sm:col-span-2">
        <Input id={`${prefix}-indirizzo`} autoComplete="street-address" className="h-12" value={value.indirizzo}
          onChange={(e) => onChange({ ...value, indirizzo: e.target.value })} data-testid={`${prefix}-indirizzo-input`} />
      </FormField>
      <FormField id={`${prefix}-cap`} label="CAP" error={errors.cap}>
        <Input id={`${prefix}-cap`} inputMode="numeric" maxLength={5} className="h-12" value={value.cap}
          onChange={(e) => onChange({ ...value, cap: e.target.value.replace(/\D/g, "") })} data-testid={`${prefix}-cap-input`} />
      </FormField>
    </div>
  );
};
